import storyNote from './story-note/storyNote';
import storyEditLink from './story-edit-link/storyEditLink';
import storyMeta from './story-meta/storyMeta';

const toLoad = [
  storyNote,
  storyEditLink,
  storyMeta
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
